import { render, staticRenderFns } from "./editOrder.vue?vue&type=template&id=184380d3&scoped=true&"
import script from "./editOrder.vue?vue&type=script&lang=js&"
export * from "./editOrder.vue?vue&type=script&lang=js&"
import style0 from "./editOrder.vue?vue&type=style&index=0&id=184380d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184380d3",
  null
  
)

export default component.exports